import React, {ReactElement} from 'react';
import {Card} from '@customink/pigment-react';
import {useAppSelector} from '../../hooks';
import {useGetStoreDetailsQuery} from '../../api/storesApi';
import CustomizationPanel from '../CustomizationPanel';
import StoreLayout from '../../layouts/StoreLayout';
import './index.scss';
import OrganizerLayoutWrapper from '../../containers/OrganizerLayoutWrapper';

type EditStoreProps = {
  storeSlug: string;
};

const EditStore: React.FC<EditStoreProps> = ({
  storeSlug
}: EditStoreProps): ReactElement => {
  useGetStoreDetailsQuery(storeSlug);
  const storeDetails = useAppSelector(state => state.stores.storeDetails);

  return (
    storeDetails && (
      <div className="editStore">
        <CustomizationPanel storeSlug={storeSlug} />
        <OrganizerLayoutWrapper>
          <div className="storePreview">
            <Card className="storePreview-card">
              <StoreLayout storeSlug={storeSlug} preview />
            </Card>
          </div>
        </OrganizerLayoutWrapper>
      </div>
    )
  );
};

export default EditStore;
